import React from 'react';
export const TitleSection = () => (
  <div className="pr-4">
    <h2 className="text-xl font-bold text-center">Discover the Benefits of TODOISTER</h2>
    <ul className="list-disc list-inside space-y-3">
      <li>
        <span className="font-bold text-sm md:text-lg">
          {' '}
          Plan & Manage: <br />
        </span>
        Organize your tasks efficiently and stay on top of your schedule.
      </li>
      <li>
        <span className="font-bold text-sm md:text-lg">
          {' '}
          Shared Projects: <br />
        </span>{' '}
        Collaborate seamlessly with your friends and teammates.
      </li>
      <li>
        <span className="font-bold text-sm md:text-lg">
          {' '}
          Calendar Integration:
          <br />
        </span>{' '}
        View and manage tasks directly in a calendar format.
      </li>
    </ul>
  </div>
);
export const TitleSection2 = () => (
  <div className="pr-4">
    <ul className="list-disc list-inside space-y-3">
      <li>
        <span className="font-bold text-sm md:text-lg">
          Customizable Lists:
          <br />
        </span>{' '}
        Separate tasks into multiple lists for better organization.
      </li>
      <li>
        <span className="font-bold text-sm md:text-lg">
          Invite Participants:
          <br />
        </span>{' '}
        Make task management a team effort by inviting others.
      </li>
    </ul>
  </div>
);
